import type { MouseEvent } from "react";

/**
 * Home while already on the home page (owner, 1 Oct 2026: "anywhere on
 * homepage ... click on the home button should come back"). A link to the
 * page you are on does nothing visible, so it scrolls back to the top
 * instead. Every other link, and Home from any other page, is left alone.
 */
export function onHomeClick(event: MouseEvent, pathname: string, href: string) {
  if (href !== "/" || pathname !== "/") return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; // new tab/window
  event.preventDefault();
  const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // A moment later, so a phone menu that is closing (and restoring the page's
  // scroll position as it unlocks) does not undo the scroll.
  window.setTimeout(() => window.scrollTo({ top: 0, behavior: smooth ? "smooth" : "auto" }), 60);
}
